import {useContext} from 'react'
import {Modal, Table} from 'react-bootstrap'
import {updateSyncByProcess} from '../../../../services/fichas'
import {showMessage} from '../../../../shared/Alerts'
import {EntityByProcessContext} from '../EntityByProcessContext'
import {DetailItem} from './DetailItem'

export const DetailModal: React.FC = () => {
  const {showModal, setShowModal, detailField, change, setChange, fetchData} =
    useContext(EntityByProcessContext)

  const handleSave = async () => {
    try {
      const params = detailField.details.map((detail) => ({
        idFicha: detail.ficha.id,
        idProceso: detail.proceso.id,
        idSeccion: detail.seccion.id,
        idCampo: detail.fieldId,
        identifier: '',
        isReadable: detail.infoAssignments.isReadable,
        isWritable: detail.infoAssignments.isWritable,
      }))

      const resp = await updateSyncByProcess(params)
      if (resp.success) {
        setChange(false)
        setShowModal(false)
        fetchData()
        showMessage('success', 'Guardado', 'Vinculaciones guardadas correctamente')
      }
    } catch (error) {
      showMessage('error', 'Error al guardar', (error as Error).message)
    }
  }

  return (
    <Modal show={showModal} onHide={() => setShowModal(false)} size='xl' centered>
      <Modal.Header closeButton>
        <Modal.Title>Detalle de vinculaciones</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mb-5'>
          <h5>Campo colaborador: {detailField.field}</h5>
        </div>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Proceso</th>
              <th>Ficha</th>
              <th>Sección</th>
              <th>Campo</th>
              <th>Vinculo</th>
            </tr>
          </thead>
          <tbody>
            {detailField.details.length > 0 ? (
              detailField.details.map((detail, index) => (
                <DetailItem key={`${detail.fieldId}-${index}`} detail={detail} />
              ))
            ) : (
              <tr>
                <td colSpan={5} className='text-center text-muted'>
                  No hay vinculaciones para mostrar
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        {change && (
          <button type='button' className='btn btn-primary' onClick={handleSave}>
            Guardar
          </button>
        )}
        <button type='button' className='btn btn-light-primary' onClick={() => setShowModal(false)}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  )
}
